"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appleReplicaSpiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function appleReplicaSpiClient(networkClient) {
    return {
        getSpendDetails: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/spi/v2/apple-replica/campaigns/${params.id}/budgets/spend`, query);
        },
        getCampaignUplift: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/spi/v2/apple-replica/campaigns/${params.id}/budgets/uplift`, query);
        },
        sendReplicateCampaign: (message) => {
            networkClient.fireToTopic(data_lib_1.SUBMIT_REPLICA_UPDATE_TOPIC, message, "Unable to send replicate campaign message, error=");
        },
        getActiveKeywordRefs: async (query) => {
            return networkClient.getHttp(data_lib_1.APPLE_REPLICA_WEB_SERVICE, `/spi/v2/apple-replica/active-keywords`, query);
        },
    };
}
exports.appleReplicaSpiClient = appleReplicaSpiClient;
